import InfiniteScroll from 'react-infinite-scroll-component';

export const InfiniteScrollHandle = ({
  children,
  dataLength,
  total,
  fetchData,
  idName,
  styles = {},
  inverse = false,
  endMessage,
}) => {
  const loadMoreData = () => {
    fetchData();
  };

  return (
    <InfiniteScroll
      dataLength={dataLength}
      next={loadMoreData}
      hasMore={total > dataLength}
      scrollableTarget={idName}
      className="scrollBlock"
      style={styles}
      inverse={inverse}
      scrollThreshold={0.6}
      endMessage={endMessage}
    >
      {children}
    </InfiniteScroll>
  );
};
